// removed by extract-text-webpack-plugin
module.exports = {"dialog":"app-pages-Employees-Pin-SaveAppPermissionModal-__SaveAppPermissionModal___1TuhQ","title":"app-pages-Employees-Pin-SaveAppPermissionModal-__SaveAppPermissionModal___3uni-","body":"app-pages-Employees-Pin-SaveAppPermissionModal-__SaveAppPermissionModal___3e2_6"};


//////////////////
// WEBPACK FOOTER
// ./app/pages/Employees/Pin/SaveAppPermissionModal/SaveAppPermissionModal.css
// module id = 2324
// module chunks = 0